import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useLenis from "@/hooks/useLenis";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Services from "@/components/Services";
import Process from "@/components/Process";
import ContactForm from "@/components/ContactForm";

export default function Home() {
  useLenis();
  const location = useLocation();

  // Support /#section deep links.
  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 100);
    }
  }, [location]);

  return (
    <div data-testid="home-page" className="relative">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <Services />
        <Process />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
